import { promotions } from '@/mocks/promotions';

export default function Promotions() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-900/40">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            限时优惠活动
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            丰富多样的优惠活动，新人礼包、每日返水、周末狂欢，让您的每一次游戏都物超所值。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="group relative bg-background-900 rounded-xl overflow-hidden border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-3px] cursor-pointer"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={promo.imageUrl}
                  alt={promo.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-[10px] font-semibold text-background-950 bg-primary-500 rounded-full whitespace-nowrap">
                    {promo.badge}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors">
                  {promo.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">{promo.description}</p>
                <button className="mt-3 px-4 py-2 text-xs font-medium text-primary-400 border border-primary-500/30 hover:bg-primary-500/10 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
                  立即参与
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}